import _ from "lodash";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  handleLessonModal,
  editLesson,
  fetchSingleLessonAttachment,
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
} from "CourseAction";
import LocaleStrings from "Languages";

class CourseChapterLessons extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {}

  edit = () => {
    var { session, printItem, chapter, source } = this.props;
    var obj = {
      chapterid: printItem.chapterid,
      chaptername: chapter.chaptername,
    };

    this.props.handleLessonModal({
      showModal: true,
      lessonType: "old-chapter",
      chapteData: obj,
    });
    this.props.editLesson(printItem);

    this.props.fetchSingleLessonAttachment(session, printItem, (response) => {


      let textData = _.filter(response.resource, (obj) => {
        return obj.type === "text";
      });
      let documentData = _.filter(response.resource, (obj) => {
        return obj.type === "document";
      });
      let videoData = _.filter(response.resource, (obj) => {
        return obj.type === "video";
      });
      let audioData = _.filter(response.resource, (obj) => {
        return obj.type === "audio";
      });
      let linkData = _.filter(response.resource, (obj) => {
        return obj.type === "link";
      });

      if (textData.length > 0) {
        let textAttachment = [];
        _.map(textData, (item, index) => {
          let data = {
            key: item.type,
            fixed: index == 0 ? true : false,
            value: item.content,
            field: "old",
            attid: item.id,
          };

          textAttachment.push(data);
        });

        this.props.textAttachmentData(textAttachment);
      }

      if (documentData.length > 0) {
        let documentAttachment = [];
        _.map(documentData, (item, index) => {
          let file = item.content;
          let f1 = file.split("/").pop();
          let f2 = f1.split("_");
          f2.splice(0, 1);
          let fileName = f2.join("_");

          let data = {
            key: item.type,
            fixed: index == 0 ? true : false,
            file: file,
            filename: fileName,
            field: "old",
            attid: item.id,
          };

          documentAttachment.push(data);
        });

        this.props.documentAttachmentData(documentAttachment);
      }

      if (videoData.length > 0) {
        let videoAttachment = [];
        _.map(videoData, (item, index) => {
          let file = item.content;
          let f1 = file.split("/").pop();
          let f2 = f1.split("_");
          f2.splice(0, 1);
          let fileName = f2.join("_");

          let data = {
            key: item.type,
            fixed: index == 0 ? true : false,
            file: file,
            filename: fileName,
            thumbnail: item.contentvideothumbnail,
            field: "old",
            attid: item.id,
          };

          videoAttachment.push(data);
        });

        this.props.videoAttachmentData(videoAttachment);
      }

      if (audioData.length > 0) {
        let audioAttachment = [];
        _.map(audioData, (item, index) => {
          let file = item.content;
          let f1 = file.split("/").pop();
          let f2 = f1.split("_");
          f2.splice(0, 1);
          let fileName = f2.join("_");

          let data = {
            key: item.type,
            fixed: index == 0 ? true : false,
            file: file,
            filename: fileName,
            field: "old",
            attid: item.id,
          };

          audioAttachment.push(data);
        });

        this.props.audioAttachmentData(audioAttachment);
      }

      if (linkData.length > 0) {
        let linkAttachment = [];
        _.map(linkData, (item, index) => {
          let data = {
            key: item.type,
            fixed: index == 0 ? true : false,
            value: item.content,
            field: "old",
            attid: item.id,
          };

          linkAttachment.push(data);
        });

        this.props.linkAttachmentData(linkAttachment);
      }
    });
  };

  render() {
    var { printItem, source } = this.props;

    return (
      <div className="w-100">
        <div className="lessons-details">
          <div className="row">
            <div className="col-md-6 lesson-name">{printItem.lessontitle}</div>

            {source == "main-page" ? (
              <div className="col-md-6 lesson-actions">
                <span
                  onClick={this.edit}
                  className="lesson-action lesson-action-texticon"
                >
                  <i className="fa fa-pencil" aria-hidden="false"></i>{" "}
                  {LocaleStrings.button_edit_content}
                </span>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
  };
}

export default connect(mapStateToProps, {
  handleLessonModal,
  editLesson,
  fetchSingleLessonAttachment,
  textAttachmentData,
  documentAttachmentData,
  videoAttachmentData,
  audioAttachmentData,
  linkAttachmentData,
})(CourseChapterLessons);
